<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="成果名称" min-width="100" >
            <template slot-scope="scope">
              {{ scope.row.achievement_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成果完成单位">
            <template slot-scope="scope">
              {{ scope.row.achievement_complete_unit || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="批准登记号">
            <template slot-scope="scope">
              {{ scope.row.approval_registration_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="批准登记单位">
            <template slot-scope="scope">
              {{ scope.row.approval_registration_unit || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成果完成人">
            <template slot-scope="scope">
              {{ scope.row.achievement_task_completor || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成果登记年份">
            <template slot-scope="scope">
              {{ scope.row.achievement_registration_year || '-' }}
            </template>
        </el-table-column>
         
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'techAchievementList',
    data() {
        return {
            title: '科技成果',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>